"use client";
import Image from "next/image";
import Link from "next/link"; // Import Link from Next.js
import { StepProps } from "../../Steps.types";

export default function Steps_About_Layout2({ data }: StepProps) {
  // Safely check if `data.Step` is an array and provide fallback to an empty array if not
  const steps = Array.isArray(data?.Step) ? data.Step : [];

  return (
    <div className="w-full bg-white py-6">
      <div className="max-w-7xl mx-auto px-4">
        <div
          className="
            grid 
            grid-cols-2 
            md:grid-cols-4 
            lg:grid-cols-6
            gap-x-12
            gap-y-12
          "
        >
          {steps.length > 0 ? (
            steps.map((step) => {
              // Using optional chaining to safely access properties of `step`
              const imageUrl = step?.iconImage?.data?.attributes?.url ?? "";
              const title = step?.title ?? "Untitled"; // Default title if undefined
              const href = step?.href ?? ""; // Extract href

              const content = (
                <div
                  key={step?.id || Math.random()} // Fallback to random number if `id` is missing
                  className="flex flex-col items-center cursor-pointer mx-auto"
                >
                  <div className="w-36 h-36 md:w-40 md:h-40 rounded-full overflow-hidden bg-gray-100 shadow-sm group">
                    {imageUrl ? (
                      <Image
                        src={imageUrl}
                        alt={title}
                        width={180}
                        height={180}
                        className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-300"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
                        No Image
                      </div>
                    )}
                  </div>

                  <h3 className="mt-4 text-center text-base font-semibold text-gray-900 leading-tight">
                    {title}
                  </h3>
                </div>
              );

              // If href is available, wrap in Link to make it clickable
              return href ? (
                <Link key={step?.id} href={href}>
                  {content}
                </Link>
              ) : (
                content
              );
            })
          ) : (
            <p className="col-span-full text-center text-gray-500">
              No steps available.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

// "use client";
// import Image from "next/image";
// import { StepProps } from "../../Steps.types";

// export default function Steps_About_Layout2({ data }: StepProps) {
//   const steps = Array.isArray(data?.Step) ? data.Step : [];
//   console.log("Steps_About_Layout2 data:", data);
//   return (
//     <div className="w-full bg-white py-6">
//       <div className="max-w-7xl mx-auto px-4">
//         <div
//           className="
//             grid
//             grid-cols-2
//             md:grid-cols-4
//             lg:grid-cols-6
//             gap-x-12
//             gap-y-12
//           "
//         >
//           {steps.length > 0 ? (
//             steps.map((step) => {
//               const imageUrl = step?.iconImage?.data?.attributes?.url || "";
//               const title = step?.title || "Untitled";

//               return (
//                 <div
//                   key={step?.id || Math.random()}
//                   className="flex flex-col items-center cursor-pointer mx-auto"
//                 >
//                   <div className="w-36 h-36 md:w-40 md:h-40 rounded-full overflow-hidden bg-gray-100 shadow-sm group">
//                     {imageUrl ? (
//                       <Image
//                         src={imageUrl}
//                         alt={title}
//                         width={180}
//                         height={180}
//                         className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-300"
//                       />
//                     ) : (
//                       <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
//                         No Image
//                       </div>
//                     )}
//                   </div>

//                   <h3 className="mt-4 text-center text-base font-semibold text-gray-900 leading-tight">
//                     {title}
//                   </h3>
//                 </div>
//               );
//             })
//           ) : (
//             <p className="col-span-full text-center text-gray-500">
//               No steps available.
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
